document.addEventListener('DOMContentLoaded', () => {
  initHcCartBundlesV2();
  document.addEventListener('theme:cart:refresh', initHcCartBundlesV2);
  document.addEventListener('theme:product:added', initHcCartBundlesV2);
  document.addEventListener('theme:cart-drawer:open', initHcCartBundlesV2);
  
  // Listen for cart updates to refresh bundle visibility
  document.addEventListener('theme:cart:update', () => {
    document.querySelectorAll('.hc-cart-bundles-v2').forEach(updateBundleVisibilityBasedOnCart);
  });
  
  // Listen for item removal from cart
  document.addEventListener('theme:cart:remove', () => {
    document.querySelectorAll('.hc-cart-bundles-v2').forEach(updateBundleVisibilityBasedOnCart);
  });
});

function initHcCartBundlesV2() {
  const bundleWrappers = document.querySelectorAll('.hc-cart-bundles-v2');

  bundleWrappers.forEach((wrap) => {
    if (wrap.dataset.listenerAttached === 'true') return;

    const toggleBtn = wrap.querySelector('.hc-bundles-toggle-btn');
    const content = wrap.querySelector('.hc-bundles-content');
    const closeBtn = wrap.querySelector('.hc-bundles-close');
    const addButtons = wrap.querySelectorAll('.hc-bundle-add-btn');
    const variantSelects = wrap.querySelectorAll('.hc-bundle-variant-select');
    const useSlider = wrap.dataset.useSlider === 'true';

    // Check current cart and update bundle visibility
    updateBundleVisibilityBasedOnCart(wrap);

    // Initialize proper states based on current state
    if (toggleBtn && content) {
      const isCurrentlyExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      const isContentVisible = !content.classList.contains('is-hidden');
      
      if (isCurrentlyExpanded || isContentVisible) {
        // Content is open by default (primary bundle)
        toggleBtn.style.display = 'none';
        toggleBtn.setAttribute('aria-expanded', 'true');
        toggleBtn.classList.add('is-expanded');
        content.classList.remove('is-hidden');
      } else {
        // Content is closed by default (secondary bundles)
        toggleBtn.style.display = 'flex';
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.classList.remove('is-expanded');
        content.classList.add('is-hidden');
      }
    }

    // Toggle functionality
    toggleBtn?.addEventListener('click', () => {
      const isExpanded = toggleBtn.getAttribute('aria-expanded') === 'true';
      if (isExpanded) {
        // Closing the content - show toggle button, hide content
        content?.classList.add('is-hidden');
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.classList.remove('is-expanded');
        toggleBtn.style.display = 'flex';
      } else {
        // Opening the content - hide toggle button, show content
        content?.classList.remove('is-hidden');
        toggleBtn.setAttribute('aria-expanded', 'true');
        toggleBtn.classList.add('is-expanded');
        toggleBtn.style.display = 'none';
      }
    });

    // Close functionality
    closeBtn?.addEventListener('click', () => {
      content?.classList.add('is-hidden');
      if (toggleBtn) {
        // Reset toggle button state and show it again
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.classList.remove('is-expanded');
        toggleBtn.style.display = 'flex';
      }
    });

    // Custom dropdown functionality
    const customSelects = wrap.querySelectorAll('.hc-custom-select');
    customSelects.forEach((customSelect) => {
      initCustomSelect(customSelect, wrap);
    });

    // Initialize slider if needed
    if (useSlider) {
      initBundleSliderV2(wrap);
    }

    // Add to cart functionality
    addButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => handleBundleAddV2(e, wrap));
    });

    wrap.dataset.listenerAttached = 'true';
  });
}

async function updateBundleVisibilityBasedOnCart(wrap) {
  try {
    // Get current cart state
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    // Get all product IDs currently in cart
    const cartProductIds = cart.items.map(item => item.product_id.toString());
    
    // Find all bundle cards in this component
    const bundleCards = wrap.querySelectorAll('.hc-bundle-card');
    
    bundleCards.forEach(card => {
      const productId = card.dataset.productId || 
                       card.querySelector('.hc-bundle-add-btn')?.dataset.productId ||
                       card.querySelector('.hc-custom-select')?.dataset.productId;
      
      if (productId && cartProductIds.includes(productId)) {
        // Product is in cart - hide the card
        card.style.display = 'none';
        card.classList.add('in-cart');
      } else {
        // Product not in cart - show the card
        card.style.display = 'flex';
        card.classList.remove('in-cart');
      }
    });
    
    // Update slider after visibility changes
    const slider = wrap.querySelector('.hc-bundles-slider, .hc-bundles-grid');
    if (slider && wrap.dataset.useSlider === 'true') {
      // Reset current slide to 0 since first visible item should be active
      const sliderInstance = wrap._sliderInstance;
      if (sliderInstance) {
        sliderInstance.currentSlide = 0;
      }
      
      // Reinitialize slider to account for hidden cards
      setTimeout(() => {
        initBundleSliderV2(wrap);
      }, 100);
    } else {
      // Even without slider, update active states for remaining cards
      updateCardActiveStatesManual(wrap);
    }
    
    // Check if all products are in cart - hide entire component if so
    const visibleCards = wrap.querySelectorAll('.hc-bundle-card:not(.in-cart)');
    if (visibleCards.length === 0) {
      wrap.style.display = 'none';
    } else {
      wrap.style.display = 'block';
    }
    
  } catch (error) {
    console.error('Error updating bundle visibility:', error);
  }
}

function updateCardActiveStatesManual(wrap) {
  const visibleCards = wrap.querySelectorAll('.hc-bundle-card:not(.in-cart)');
  
  // Remove all active/preview states first
  visibleCards.forEach(card => {
    card.classList.remove('is-active', 'is-preview');
  });
  
  // Set first visible card as active, others as preview
  if (visibleCards.length > 0) {
    visibleCards[0].classList.add('is-active');
    
    for (let i = 1; i < visibleCards.length; i++) {
      visibleCards[i].classList.add('is-preview');
    }
  }
}

function formatMoneyFromCents(value) {
  const amount = Number(value);

  if (Number.isNaN(amount)) {
    return '';
  }

  if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
    return window.Shopify.formatMoney(amount);
  }

  return `$${(amount / 100).toFixed(2)}`;
}

async function getCartItemsComponent() {
  if (window.customElements && typeof window.customElements.whenDefined === 'function') {
    try {
      await window.customElements.whenDefined('cart-items');
    } catch (error) {
      // Ignore errors from whenDefined to avoid breaking flow
    }
  }

  return document.querySelector('cart-items');
}

// Bundle discount enforcement helpers (currently unused but kept for future needs)
let evaluatingBundleDiscount = false;

function initCustomSelect(customSelect, wrap) {
  const trigger = customSelect.querySelector('.hc-custom-select-trigger');
  const options = customSelect.querySelectorAll('.hc-custom-select-option');
  const triggerText = trigger.querySelector('span');
  const productId = customSelect.dataset.productId;
  
  // Toggle dropdown
  trigger.addEventListener('click', (e) => {
    e.stopPropagation();
    
    // Close other dropdowns
    document.querySelectorAll('.hc-custom-select.open').forEach(otherSelect => {
      if (otherSelect !== customSelect) {
        otherSelect.classList.remove('open');
      }
    });
    
    customSelect.classList.toggle('open');
  });
  
  // Handle option selection
  options.forEach((option) => {
    option.addEventListener('click', (e) => {
      e.stopPropagation();
      
      const value = option.dataset.value;
      const price = option.dataset.price;
      const comparePrice = option.dataset.comparePrice;
      const text = option.textContent.trim();
      
      // Update UI
      triggerText.textContent = text;
      trigger.dataset.value = value;
      
      // Update selected state
      options.forEach(opt => opt.classList.remove('selected'));
      option.classList.add('selected');
      
      // Close dropdown
      customSelect.classList.remove('open');
      
      // Trigger change event (simulate select change)
      const changeEvent = {
        target: {
          value: value,
          selectedIndex: Array.from(options).indexOf(option),
          options: Array.from(options).map(opt => ({
            value: opt.dataset.value,
            dataset: {
              price: opt.dataset.price,
              comparePrice: opt.dataset.comparePrice,
              originalPrice: opt.dataset.originalPrice,
              discountedPrice: opt.dataset.discountedPrice,
              hasDiscount: opt.dataset.hasDiscount
            }
          })),
          dataset: { productId: productId },
          selectedOptionDataset: {
            price: option.dataset.price,
            comparePrice: option.dataset.comparePrice,
            originalPrice: option.dataset.originalPrice,
            discountedPrice: option.dataset.discountedPrice,
            hasDiscount: option.dataset.hasDiscount
          }
        }
      };
      
      handleVariantChange(changeEvent, wrap);
    });
  });
  
  // Close dropdown when clicking outside (use more specific targeting)
  const closeHandler = (e) => {
    if (!customSelect.contains(e.target)) {
      customSelect.classList.remove('open');
    }
  };
  
  // Store handler reference for cleanup
  customSelect._closeHandler = closeHandler;
  document.addEventListener('click', closeHandler);
}

function handleVariantChange(event, wrap) {
  const target = event.target;
  const productId = target.dataset?.productId;
  let selectedIndex = target.selectedIndex;
  let selectedOption = null;

  if (target.options) {
    selectedOption = target.options[selectedIndex] || null;

    if (!selectedOption) {
      const optionsArray = Array.from(target.options);
      selectedOption = optionsArray.find((opt) => (opt.value || opt.dataset?.value) === target.value) || null;
      selectedIndex = optionsArray.indexOf(selectedOption);
    }
  }

  const variantId = target.value;
  const optionDataset = target.selectedOptionDataset || selectedOption?.dataset || {};

  const originalPriceRaw = optionDataset.originalPrice ?? optionDataset.price ?? 0;
  const discountedPriceRaw = optionDataset.discountedPrice ?? originalPriceRaw;
  const comparePriceRaw = optionDataset.comparePrice ?? 0;

  let originalPriceCents = Number(originalPriceRaw);
  let discountedPriceCents = Number(discountedPriceRaw);
  let comparePriceCents = Number(comparePriceRaw);

  if (Number.isNaN(originalPriceCents)) originalPriceCents = 0;
  if (Number.isNaN(discountedPriceCents)) discountedPriceCents = originalPriceCents;
  if (Number.isNaN(comparePriceCents)) comparePriceCents = 0;

  const hasBundleDiscount = String(optionDataset.hasDiscount).toLowerCase() === 'true' && discountedPriceCents >= 0 && discountedPriceCents < originalPriceCents;

  // Find the corresponding price container and button
  const priceContainer = wrap.querySelector(`.hc-bundle-price[data-product-id="${productId}"]`);
  const addButton = wrap.querySelector(`.hc-bundle-add-btn[data-product-id="${productId}"]`);

  if (priceContainer) {
    const currentPriceElement = priceContainer.querySelector('.hc-bundle-price-current');
    let comparePriceElement = priceContainer.querySelector('.hc-bundle-price-compare');

    if (!comparePriceElement) {
      comparePriceElement = document.createElement('span');
      comparePriceElement.className = 'hc-bundle-price-compare';
      priceContainer.appendChild(comparePriceElement);
    }

    // Update current price
    if (currentPriceElement) {
      const priceToDisplay = hasBundleDiscount ? discountedPriceCents : originalPriceCents;
      currentPriceElement.textContent = formatMoneyFromCents(priceToDisplay);
      currentPriceElement.classList.toggle('is-discounted', hasBundleDiscount);
    }

    const hasCompareAtSale = !hasBundleDiscount && comparePriceCents > originalPriceCents;

    if (hasBundleDiscount && originalPriceCents > 0) {
      comparePriceElement.textContent = formatMoneyFromCents(originalPriceCents);
      comparePriceElement.style.display = 'inline';
    } else {
      if (hasCompareAtSale) {
        comparePriceElement.textContent = formatMoneyFromCents(comparePriceCents);
        comparePriceElement.style.display = 'inline';
      } else {
        comparePriceElement.style.display = 'none';
      }
    }

    priceContainer.dataset.originalPrice = originalPriceCents;
    priceContainer.dataset.discountedPrice = discountedPriceCents;
    priceContainer.dataset.hasDiscount = hasBundleDiscount;
  }

  // Update button variant ID
  if (addButton) {
    addButton.dataset.variantId = variantId;
  }
}

function initBundleSliderV2(container) {
  const track = container.querySelector('.hc-bundles-track');
  const cards = container.querySelectorAll('.hc-bundle-card:not(.in-cart)'); // Only count visible cards
  const prevBtn = container.querySelector('.hc-bundles-prev');
  const nextBtn = container.querySelector('.hc-bundles-next');
  
  if (!track || cards.length === 0) return;

  let currentSlide = 0;
  const totalSlides = cards.length;
  
  // Store slider instance on container for external access
  const sliderInstance = {
    currentSlide: 0,
    totalSlides: totalSlides,
    cards: cards
  };
  container._sliderInstance = sliderInstance;
  
  // Dynamic items per slide based on screen size and available items
  function getItemsPerSlide() {
    // Always show 1 item per slide with preview of next
    return 1;
  }
  
  // Get slide percentage - consistent across all devices
  function getSlidePercentage() {
    // Always use 90% movement to match 90% card width
    return 90;
  }
  
  let itemsPerSlide = getItemsPerSlide();
  let slidePercentage = getSlidePercentage();
  let maxSlideIndex = Math.max(0, totalSlides - 1); // Allow each item to be the main focus
  let isAnimating = false;

  // Set initial positions
  updateSliderPosition();
  updateNavigation();
  
  // Initialize card active states
  updateCardActiveStates();
  
  // Update on window resize
  function handleResize() {
    const newItemsPerSlide = getItemsPerSlide();
    const newSlidePercentage = getSlidePercentage();
    
    if (newItemsPerSlide !== itemsPerSlide || newSlidePercentage !== slidePercentage) {
      itemsPerSlide = newItemsPerSlide;
      slidePercentage = newSlidePercentage;
      maxSlideIndex = Math.max(0, totalSlides - 1); // Allow each item to be the main focus
      currentSlide = Math.min(currentSlide, maxSlideIndex);
      updateSliderPosition();
      updateNavigation();
    }
  }

  // Previous button
  prevBtn?.addEventListener('click', () => {
    if (isAnimating || currentSlide === 0) return;
    currentSlide = Math.max(0, currentSlide - 1);
    updateSliderPosition();
    updateNavigation();
  });

  // Next button
  nextBtn?.addEventListener('click', () => {
    if (isAnimating || currentSlide >= maxSlideIndex) return;
    currentSlide = Math.min(maxSlideIndex, currentSlide + 1);
    updateSliderPosition();
    updateNavigation();
  });

  // Touch/swipe support with improved vertical scroll handling
  let startX = 0;
  let startY = 0;
  let isDragging = false;
  let startTransform = 0;
  let isHorizontalSwipe = false;
  let hasDragged = false; // Track if user has dragged

  // Prevent clicks on product links when dragging
  const preventClickDuringDrag = (e) => {
    if (hasDragged) {
      e.preventDefault();
      e.stopPropagation();
      // Reset flag after short delay to ensure click is blocked
      setTimeout(() => {
        hasDragged = false;
      }, 100);
      return false;
    }
  };

  // Add click prevention to all product links in this slider
  container.querySelectorAll('.hc-bundle-media a').forEach(link => {
    link.addEventListener('click', preventClickDuringDrag, true); // Capture phase
  });

  track.addEventListener('touchstart', handleTouchStart, { passive: true });
  track.addEventListener('touchmove', handleTouchMove, { passive: false });
  track.addEventListener('touchend', handleTouchEnd, { passive: true });

  // Mouse events for desktop
  track.addEventListener('mousedown', handleMouseStart);
  track.addEventListener('mousemove', handleMouseMove);
  track.addEventListener('mouseup', handleMouseEnd);
  track.addEventListener('mouseleave', handleMouseEnd);

  function handleTouchStart(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isDragging = false; // Don't start dragging immediately
    isHorizontalSwipe = false;
    startTransform = currentSlide * -slidePercentage; // Use dynamic slidePercentage
    track.style.transition = 'none';
  }

  function handleTouchMove(e) {
    if (!isDragging && !isHorizontalSwipe) {
      // Determine swipe direction on first move
      const currentX = e.touches[0].clientX;
      const currentY = e.touches[0].clientY;
      const diffX = Math.abs(currentX - startX);
      const diffY = Math.abs(currentY - startY);
      
      // If horizontal movement is greater than vertical, it's a horizontal swipe
      if (diffX > diffY && diffX > 10) {
        isHorizontalSwipe = true;
        isDragging = true;
      } else if (diffY > diffX && diffY > 10) {
        // Vertical swipe - let the page handle it
        return;
      } else {
        // Not enough movement yet
        return;
      }
    }
    
    if (!isDragging || !isHorizontalSwipe) return;
    
    e.preventDefault(); // Only prevent default for horizontal swipes
    
    const currentX = e.touches[0].clientX;
    const diffX = currentX - startX;
    const cardWidth = track.offsetWidth;
    const movePercent = (diffX / cardWidth) * slidePercentage; // Use dynamic slidePercentage
    
    track.style.transform = `translateX(${startTransform + movePercent}%)`;
  }

  function handleTouchEnd(e) {
    if (!isDragging || !isHorizontalSwipe) {
      // Reset and allow normal scrolling
      track.style.transition = '';
      return;
    }
    
    isDragging = false;
    isHorizontalSwipe = false;
    
    const endX = e.changedTouches[0].clientX;
    const diffX = endX - startX;
    const threshold = 50; // Minimum swipe distance
    
    // Mark as dragged if moved significantly
    if (Math.abs(diffX) > 10) {
      hasDragged = true;
    }
    
    track.style.transition = '';
    
    if (Math.abs(diffX) > threshold) {
      if (diffX > 0 && currentSlide > 0) {
        // Swipe right - go to previous
        currentSlide = Math.max(0, currentSlide - 1);
      } else if (diffX < 0 && currentSlide < maxSlideIndex) {
        // Swipe left - go to next
        currentSlide = Math.min(maxSlideIndex, currentSlide + 1);
      }
    }
    
    updateSliderPosition();
    updateNavigation();
  }

  function handleMouseStart(e) {
    e.preventDefault();
    startX = e.clientX;
    isDragging = true;
    startTransform = currentSlide * -slidePercentage; // Use dynamic slidePercentage
    track.style.transition = 'none';
    track.style.cursor = 'grabbing';
  }

  function handleMouseMove(e) {
    if (!isDragging) return;
    e.preventDefault();
    
    const currentX = e.clientX;
    const diffX = currentX - startX;
    const cardWidth = track.offsetWidth;
    const movePercent = (diffX / cardWidth) * slidePercentage; // Use dynamic slidePercentage
    
    track.style.transform = `translateX(${startTransform + movePercent}%)`;
  }

  function handleMouseEnd(e) {
    if (!isDragging) return;
    isDragging = false;
    
    const endX = e.clientX;
    const diffX = endX - startX;
    const threshold = 50;
    
    // Mark as dragged if moved significantly  
    if (Math.abs(diffX) > 10) {
      hasDragged = true;
    }
    
    track.style.transition = '';
    track.style.cursor = 'grab'; // Reset to grab instead of empty string
    
    if (Math.abs(diffX) > threshold) {
      if (diffX > 0 && currentSlide > 0) {
        currentSlide = Math.max(0, currentSlide - 1);
      } else if (diffX < 0 && currentSlide < maxSlideIndex) {
        currentSlide = Math.min(maxSlideIndex, currentSlide + 1);
      }
    }
    
    updateSliderPosition();
    updateNavigation();
  }

  function updateSliderPosition() {
    isAnimating = true;
    // Get only visible cards for calculation
    const visibleCards = Array.from(cards).filter(card => !card.classList.contains('in-cart'));
    
    // Reset currentSlide if it exceeds visible cards
    if (currentSlide >= visibleCards.length) {
      currentSlide = Math.max(0, visibleCards.length - 1);
    }
    
    // Use dynamic slide percentage based on screen size
    track.style.transform = `translateX(-${currentSlide * slidePercentage}%)`;
    
    // Update active states for cards
    updateCardActiveStates();
    
    // Reset animation flag after transition
    setTimeout(() => {
      isAnimating = false;
    }, 300);
  }

  function updateCardActiveStates() {
    // Get only visible cards (not in cart)
    const visibleCards = Array.from(cards).filter(card => !card.classList.contains('in-cart'));
    
    // Remove all existing states from ALL cards
    cards.forEach(card => {
      card.classList.remove('is-active', 'is-preview');
    });
    
    // Add active state to current slide (among visible cards)
    if (visibleCards[currentSlide]) {
      visibleCards[currentSlide].classList.add('is-active');
    }
    
    // Add preview state to other visible cards
    visibleCards.forEach((card, index) => {
      if (index !== currentSlide) {
        card.classList.add('is-preview');
      }
    });
    
    // Update slider instance
    if (container._sliderInstance) {
      container._sliderInstance.currentSlide = currentSlide;
      container._sliderInstance.visibleCards = visibleCards;
    }
  }

  function updateNavigation() {
    // Get visible cards count for navigation
    const visibleCards = Array.from(cards).filter(card => !card.classList.contains('in-cart'));
    const maxVisibleIndex = Math.max(0, visibleCards.length - 1);
    
    if (prevBtn) {
      prevBtn.disabled = currentSlide === 0;
    }
    if (nextBtn) {
      nextBtn.disabled = currentSlide >= maxVisibleIndex;
    }
  }

  // Auto-resize handler
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      handleResize();
    }, 100);
  });
}

async function handleBundleAddV2(event, wrap) {
  const btn = event.currentTarget;
  const variantId = btn.dataset.variantId;
  const productTitle = btn.dataset.productTitle;
  const discountCode = btn.dataset.discountCode ? btn.dataset.discountCode.trim() : '';
  const parentProductId = btn.dataset.parentProductId || '';
  const parentVariantId = btn.dataset.parentVariantId || '';
  const parentLineKey = btn.dataset.parentLineKey || '';

  // Show loading state
  const btnText = btn.querySelector('.hc-bundle-btn-text');
  const btnLoading = btn.querySelector('.hc-bundle-btn-loading');
  
  btn.disabled = true;
  btnText?.classList.add('is-hidden');
  btnLoading?.classList.remove('is-hidden');

  try {
    // Simple add to cart - no replacement logic
    const bundleProperties = {
      _added_from_bundle: true,
      _bundle_product_title: productTitle,
    };

    if (discountCode) {
      bundleProperties._bundle_discount_code = discountCode;
    }

    if (parentProductId) {
      bundleProperties._bundle_parent_product_id = parentProductId;
    }

    if (parentVariantId) {
      bundleProperties._bundle_parent_variant_id = parentVariantId;
    }

    if (parentLineKey) {
      bundleProperties._bundle_parent_line_key = parentLineKey;
    }

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: bundleProperties
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();

    // Show success feedback
    showBundleSuccessV2(btn, productTitle);
    
    // Update bundle visibility after adding to cart
    await updateBundleVisibilityBasedOnCart(wrap);

    // Apply discount code if provided
    if (discountCode) {
      await applyBundleDiscountCode(discountCode);
    }

  } catch (error) {
    console.error('Bundle add failed:', error);
    showBundleErrorV2(btn, 'Failed to add item to cart');
  } finally {
    // Reset loading state
    btn.disabled = false;
    btnText?.classList.remove('is-hidden');
    btnLoading?.classList.add('is-hidden');
    
    // Refresh cart UI and update bundle visibility
    document.dispatchEvent(new CustomEvent('theme:cart:refresh'));
    
    // Update visibility for this specific component
    await updateBundleVisibilityBasedOnCart(wrap);
  }
}

function showBundleSuccessV2(btn, productTitle) {
  const originalText = btn.querySelector('.hc-bundle-btn-text').textContent;
  const btnText = btn.querySelector('.hc-bundle-btn-text');
  
  if (btnText) {
    btnText.textContent = 'Added!';
    
    setTimeout(() => {
      btnText.textContent = originalText;
    }, 2000);
  }
}

function showBundleErrorV2(btn, message) {
  const originalText = btn.querySelector('.hc-bundle-btn-text').textContent;
  const btnText = btn.querySelector('.hc-bundle-btn-text');
  
  if (btnText) {
    btnText.textContent = 'Error';
    
    setTimeout(() => {
      btnText.textContent = originalText;
    }, 2000);
  }
  
  console.error('Bundle Error:', message);
}

async function applyBundleDiscountCode(discountCode) {
  const trimmedCode = discountCode.trim();

  if (!trimmedCode) return;

  try {
    const cartItemsComponent = await getCartItemsComponent();

    if (cartItemsComponent && typeof cartItemsComponent.applyDiscount === 'function') {
      cartItemsComponent.applyDiscount(trimmedCode);
      return;
    }

    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();

    const activeCodes = Array.isArray(cart.discount_codes)
      ? cart.discount_codes
          .filter((codeObj) => codeObj && codeObj.code)
          .map((codeObj) => codeObj.code)
      : [];

    const alreadyApplied = activeCodes.some((code) => String(code).toLowerCase() === trimmedCode.toLowerCase());

    if (alreadyApplied) return;

    activeCodes.push(trimmedCode);

    const updateUrl = window.theme?.routes?.cart_update_url || '/cart/update.js';

    await fetch(updateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        discount: activeCodes.join(','),
      }),
    });
  } catch (error) {
    console.error('Failed to apply bundle discount code:', error);
  }
}

async function removeBundleDiscountCode(discountCode, currentCodes = []) {
  const trimmedCode = discountCode.trim();

  if (!trimmedCode) return;

  try {
    const cartItemsComponent = await getCartItemsComponent();

    if (cartItemsComponent && typeof cartItemsComponent.removeDiscount === 'function') {
      cartItemsComponent.removeDiscount(trimmedCode);
      return;
    }

    let activeCodes = Array.isArray(currentCodes) && currentCodes.length ? currentCodes.slice() : null;

    if (!activeCodes) {
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();

      activeCodes = Array.isArray(cart.discount_codes)
        ? cart.discount_codes
            .filter((codeObj) => codeObj && codeObj.code)
            .map((codeObj) => codeObj.code)
        : [];
    }

    const filteredCodes = activeCodes.filter((code) => code && code.toLowerCase() !== trimmedCode.toLowerCase());

    if (filteredCodes.length === activeCodes.length) {
      return;
    }

    const updateUrl = window.theme?.routes?.cart_update_url || '/cart/update.js';

    await fetch(updateUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        discount: filteredCodes.join(','),
      }),
    });
  } catch (error) {
    console.error('Failed to remove bundle discount code:', error);
  }
}

async function evaluateBundleDiscountEligibility(cart) {
  if (evaluatingBundleDiscount) return;

  evaluatingBundleDiscount = true;

  try {
    const discountEntries = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];

    if (!discountEntries.length) return;

    const activeCodeMap = new Map();

    discountEntries.forEach((entry) => {
      const code = (entry?.code || '').trim();
      if (code) {
        activeCodeMap.set(code.toLowerCase(), code);
      }
    });

    if (!activeCodeMap.size) return;

    const productIdsInCart = new Set(
      Array.isArray(cart.items) ? cart.items.map((item) => String(item.product_id)) : []
    );

    const eligibleCodes = new Set();
    const trackedCodes = new Set();

    cart.items?.forEach((item) => {
      const properties = item.properties || {};

      if (!properties || !properties._added_from_bundle) return;

      const rawCode = (properties._bundle_discount_code || '').trim();
      if (!rawCode) return;

      const rawCodeLower = rawCode.toLowerCase();
      trackedCodes.add(rawCodeLower);

      const parentProductId = properties._bundle_parent_product_id
        ? String(properties._bundle_parent_product_id)
        : '';

      if (parentProductId && productIdsInCart.has(parentProductId)) {
        eligibleCodes.add(rawCodeLower);
      }
    });

    const codesToRemove = [];

    trackedCodes.forEach((codeLower) => {
      if (!eligibleCodes.has(codeLower)) {
        const actualCode = activeCodeMap.get(codeLower);
        if (actualCode) {
          codesToRemove.push(actualCode);
        }
      }
    });

    if (!codesToRemove.length) return;

    let currentCodesArray = Array.from(activeCodeMap.values());

    for (const code of codesToRemove) {
      await removeBundleDiscountCode(code, currentCodesArray);
      currentCodesArray = currentCodesArray.filter((activeCode) => activeCode && activeCode.toLowerCase() !== code.toLowerCase());
    }
  } finally {
    evaluatingBundleDiscount = false;
  }
}

async function evaluateBundleDiscountForCart() {
  try {
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    await evaluateBundleDiscountEligibility(cart);
  } catch (error) {
    console.error('Failed to evaluate bundle discount for cart:', error);
  }
}
